import EventBus from "./eventBus";

const DEFAULT_HOTKEYS = [
  {
    code: "KeyW",
    altKey: true,
    shiftKey: true,
    ctrlKey: false,
    metaKey: false,
    event: "hotkey:next-camera",
  },
  {
    code: "KeyP",
    altKey: true,
    shiftKey: true,
    ctrlKey: false,
    metaKey: false,
    event: "hotkey:primary-camera",
  },
  {
    code: "KeyA",
    altKey: true,
    shiftKey: true,
    ctrlKey: false,
    metaKey: false,
    event: "hotkey:toggle-auto-switch",
  },
  {
    code: "KeyA",
    altKey: false,
    shiftKey: true,
    ctrlKey: false,
    metaKey: false,
    event: "hotkey:toggle-auto-switch",
  },
];

export default class HotkeyController {
  constructor({
    bus = new EventBus(),
    layoutManager,
    hotkeys = DEFAULT_HOTKEYS,
  } = {}) {
    this.bus = bus;
    this.layoutManager = layoutManager;
    this.hotkeys = Array.isArray(hotkeys) ? hotkeys : DEFAULT_HOTKEYS;
    this.listener = this.handleKeyPress.bind(this);
    this.enabled = false;
  }

  enable() {
    if (this.enabled) return;
    window.addEventListener("keydown", this.listener, { passive: false });
    this.enabled = true;
  }

  disable() {
    if (!this.enabled) return;
    window.removeEventListener("keydown", this.listener, { passive: false });
    this.enabled = false;
  }

  handleKeyPress(event) {
    if (this.shouldIgnoreEvent(event)) return;

    const shortcut = this.hotkeys.find((descriptor) =>
      this.matchesShortcut(event, descriptor)
    );
    if (!shortcut) return;

    event.preventDefault();
    this.bus.emit(shortcut.event);
  }

  destroy() {
    this.disable();
  }

  matchesShortcut(event, descriptor) {
    if (!descriptor) return false;
    const {
      code,
      altKey = false,
      shiftKey = false,
      ctrlKey = false,
      metaKey = false,
    } = descriptor;

    return (
      event.code === code &&
      Boolean(event.altKey) === Boolean(altKey) &&
      Boolean(event.shiftKey) === Boolean(shiftKey) &&
      Boolean(event.ctrlKey) === Boolean(ctrlKey) &&
      Boolean(event.metaKey) === Boolean(metaKey)
    );
  }

  shouldIgnoreEvent(event) {
    const target = event.target;
    if (!target) return false;
    const tagName = target.tagName;
    if (!tagName) return false;
    const normalized = tagName.toLowerCase();
    if (
      normalized === "input" ||
      normalized === "textarea" ||
      normalized === "select"
    ) {
      return target.type !== "checkbox" && target.type !== "radio";
    }
    return Boolean(target.isContentEditable);
  }
}
